import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  Container,
  Paper,
  Box,
  TextField,
  Button,
  Typography,
  Alert,
  InputAdornment,
  IconButton,
  Avatar,
} from "@mui/material";
import { Visibility, VisibilityOff, Shield } from "@mui/icons-material";
import axios from "axios";

const SuperAdminLogin = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    username: "",
    password: "",
  });
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
    setError("");
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/super-admin/login`,
        formData
      );

      if (response.data.success) {
        // حفظ Token والمعلومات
        localStorage.setItem("superAdminToken", response.data.data.token);
        localStorage.setItem(
          "superAdmin",
          JSON.stringify(response.data.data.admin)
        );

        // الانتقال إلى Dashboard
        navigate("/super-admin/dashboard");
      }
    } catch (err) {
      setError(err.response?.data?.message || "فشل تسجيل الدخول");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box
      sx={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
      }}
    >
      <Container maxWidth="sm">
        <Paper elevation={10} sx={{ p: 4, borderRadius: 3 }}>
          <Box textAlign="center" mb={3}>
            <Avatar
              sx={{
                width: 80,
                height: 80,
                margin: "0 auto",
                bgcolor: "primary.main",
                mb: 2,
              }}
            >
              <Shield sx={{ fontSize: 50 }} />
            </Avatar>
            <Typography variant="h4" fontWeight="bold" gutterBottom>
              Super Admin
            </Typography>
            <Typography variant="body2" color="text.secondary">
              لوحة التحكم الرئيسية
            </Typography>
          </Box>

          {error && (
            <Alert severity="error" sx={{ mb: 3 }}>
              {error}
            </Alert>
          )}

          <form onSubmit={handleSubmit}>
            <TextField
              fullWidth
              label="اسم المستخدم"
              name="username"
              value={formData.username}
              onChange={handleChange}
              required
              sx={{ mb: 2 }}
              autoFocus
            />

            <TextField
              fullWidth
              label="كلمة المرور"
              name="password"
              type={showPassword ? "text" : "password"}
              value={formData.password}
              onChange={handleChange}
              required
              sx={{ mb: 3 }}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton
                      onClick={() => setShowPassword(!showPassword)}
                      edge="end"
                    >
                      {showPassword ? <VisibilityOff /> : <Visibility />}
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />

            <Button
              type="submit"
              fullWidth
              variant="contained"
              size="large"
              disabled={loading}
              sx={{ py: 1.5 }}
            >
              {loading ? "جاري تسجيل الدخول..." : "تسجيل الدخول"}
            </Button>
          </form>

          <Box textAlign="center" mt={3}>
            <Typography variant="caption" color="text.secondary">
              نظام إدارة مكاتب المحاماة v2.5
            </Typography>
          </Box>
        </Paper>
      </Container>
    </Box>
  );
};

export default SuperAdminLogin;
